import DOMpurify from "dompurify";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import rehypeRaw from "rehype-raw";
import rehypeSanitize, { defaultSchema } from "rehype-sanitize";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

const customSchema = {
  ...defaultSchema,
  tagNames: [...(defaultSchema.tagNames as []), "u"]
};

/**
 * Renders Markdown (GitHub flavour, line breaks kept) as sanitized HTML, with highlighted code
 * blocks. Raw HTML is allowed but sanitized; `<u>` is kept for underline.
 */
export const MarkdownView: React.FC<{ markdown: string }> = ({ markdown }) => {
  return (
    <div className="markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm, remarkBreaks]}
        rehypePlugins={[rehypeRaw, [rehypeSanitize, customSchema]]}
        components={{
          code(props) {
            const { children, className, node, ...rest } = props;
            const match = /language-(\w+)/.exec(className || "");
            return match ? (
              <SyntaxHighlighter
                {...(rest as object)}
                PreTag="div"
                language={match[1]}
              >
                {String(children).replace(/\n$/, "")}
              </SyntaxHighlighter>
            ) : (
              <code {...rest} className={className}>
                {children}
              </code>
            );
          }
        }}
      >
        {DOMpurify.sanitize(markdown)}
      </ReactMarkdown>
    </div>
  );
};
